"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrembidLocalStorage = void 0;
var PrembidLocalStorage = /** @class */ (function () {
    function PrembidLocalStorage() {
    }
    Object.defineProperty(PrembidLocalStorage, "currentProfile", {
        get: function () {
            var userString = sessionStorage.getItem(this._keys.current_user);
            if (userString === null) {
                return "";
            }
            else {
                var user = JSON.parse(userString);
                return user.currentProfileId;
            }
        },
        set: function (profileId) {
            var userString = sessionStorage.getItem(this._keys.current_user);
            if (userString !== null) {
                var user = JSON.parse(userString);
                user.currentProfileId = profileId;
                var userJson = JSON.stringify(user);
                sessionStorage.setItem(this._keys.current_user, userJson);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrembidLocalStorage, "currentProfileName", {
        get: function () {
            var _a;
            var userString = sessionStorage.getItem(this._keys.current_user);
            if (userString === null) {
                return "";
            }
            else {
                var user_1 = JSON.parse(userString);
                var profile = (_a = user_1.profiles) === null || _a === void 0 ? void 0 : _a.filter(function (profile) { return profile.profileId === user_1.currentProfileId; });
                if (profile && profile[0]) {
                    return profile[0].profileName;
                }
                else {
                    return "";
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrembidLocalStorage, "biddingFirebaseToken", {
        get: function () {
            return sessionStorage.getItem(this._keys.bidding_firebase_token);
        },
        set: function (token) {
            if (token)
                sessionStorage.setItem(this._keys.bidding_firebase_token, token);
        },
        enumerable: false,
        configurable: true
    });
    PrembidLocalStorage.clearBiddingFirebaseToken = function () {
        sessionStorage.removeItem(this._keys.bidding_firebase_token);
    };
    Object.defineProperty(PrembidLocalStorage, "currentUser", {
        get: function () {
            var userString = sessionStorage.getItem(this._keys.current_user);
            if (userString === null)
                return null;
            var user = JSON.parse(userString);
            return user;
        },
        set: function (user) {
            var userJson = JSON.stringify(user);
            if (userJson)
                sessionStorage.setItem(this._keys.current_user, userJson);
        },
        enumerable: false,
        configurable: true
    });
    PrembidLocalStorage.clearCurrentUser = function () {
        sessionStorage.removeItem(this._keys.current_user);
    };
    Object.defineProperty(PrembidLocalStorage, "defaultProfile", {
        //public static set profileData(newProfileData: Omit<UserProfiles, 'profileType'>) {
        //    const userString = sessionStorage.getItem(this._keys.current_user);
        //    if (userString) {
        //        const user = JSON.parse(userString) as User;
        //        const profiles = user.profiles?.map(profile => {
        //            if (profile.profileId === newProfileData.profileId) {
        //                return { ...profile, ...newProfileData };
        //            }
        //            return profile;
        //        })
        //        user.profiles = profiles ?? [];
        //        sessionStorage.setItem(this._keys.current_user, JSON.stringify(user));
        //    }
        //}
        set: function (profileId) {
            var _a;
            var userString = sessionStorage.getItem(this._keys.current_user);
            if (userString !== null) {
                var user = JSON.parse(userString);
                var profiles = (_a = user.profiles) === null || _a === void 0 ? void 0 : _a.map(function (profile) { return (__assign(__assign({}, profile), { isDefaultProfile: profile.profileId === profileId })); });
                var userJson = JSON.stringify(__assign(__assign({}, user), { profiles: profiles !== null && profiles !== void 0 ? profiles : [] }));
                sessionStorage.setItem(this._keys.current_user, userJson);
            }
        },
        enumerable: false,
        configurable: true
    });
    PrembidLocalStorage.upsertProfileToCurrentUser = function (profileId, profileName, profileEmail, profilePhoneNumber, isDefaultProfile) {
        var _a, _b, _c;
        var user = this.currentUser;
        if (!user)
            return;
        if (isDefaultProfile) {
            user.profiles = (_a = user.profiles) === null || _a === void 0 ? void 0 : _a.map(function (profile) { return (__assign(__assign({}, profile), { isDefaultProfile: profile.profileId === profileId })); });
        }
        var existingProfile = (_b = user.profiles) === null || _b === void 0 ? void 0 : _b.find(function (profile) { return profile.profileId === profileId; });
        if (existingProfile) {
            existingProfile.profileName = profileName;
            existingProfile.profileEmail = profileEmail;
            existingProfile.profilePhoneNumber = profilePhoneNumber;
            existingProfile.isDefaultProfile = isDefaultProfile;
        }
        else
            (_c = user.profiles) === null || _c === void 0 ? void 0 : _c.push({
                profileId: profileId,
                profileName: profileName,
                profileEmail: profileEmail,
                profilePhoneNumber: profilePhoneNumber,
                isDefaultProfile: isDefaultProfile,
            });
        var userJson = JSON.stringify(user);
        if (userJson) {
            sessionStorage.setItem(this._keys.current_user, userJson);
        }
    };
    PrembidLocalStorage.removeProfileFromCurrentUser = function (profileId, defaultProfileId) {
        var _a, _b;
        var user = this.currentUser;
        if (!user)
            return;
        if (defaultProfileId) {
            user.profiles = (_a = user.profiles) === null || _a === void 0 ? void 0 : _a.map(function (profile) { return (__assign(__assign({}, profile), { isDefaultProfile: profile.profileId === defaultProfileId })); });
        }
        user.profiles = (_b = user.profiles) === null || _b === void 0 ? void 0 : _b.filter(function (profile) { return profile.profileId !== profileId; });
        var userJson = JSON.stringify(user);
        if (userJson) {
            sessionStorage.setItem(this._keys.current_user, userJson);
        }
    };
    PrembidLocalStorage.removeAllData = function () {
        sessionStorage.clear();
    };
    PrembidLocalStorage._keys = {
        bidding_firebase_token: "bidding_firebase_token",
        current_user: "current_user",
        configs_version: "configs_version",
        configs: "configs",
    };
    return PrembidLocalStorage;
}());
exports.PrembidLocalStorage = PrembidLocalStorage;
